import * as React from "react";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { Description } from "@material-ui/icons";
import CoreInfoRequestInfoChip from "../../CoreInfoRequestInfoChip";

interface CoreInfoRequestHeaderProps {
  record: any;
  classes: any;
}

const CoreInfoRequestHeader: React.FC<CoreInfoRequestHeaderProps> = ({ record, classes }) => {
  return (
    <Card className={classes.card}>
      <CardContent>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" className={classes.cardTitle}>
              <Description /> Core Info Request Details
            </Typography>
          </Grid>
          <Grid item>
            <CoreInfoRequestInfoChip record={record} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CoreInfoRequestHeader;
